import * as React from 'react'
import { scaleImageUrl } from '../../../../../utils/image'

// Note on picture:
// Browsers which do not support picture still need to trigger onLoad and onError so it must
// be in the img tag. Browsers which do support picture, understand that these events should
// trigger even if they use the WebP source.

interface BasicImageProps {
  url: string
  alternateText?: string
  defaultWidth: number
  onError?: (event: React.SyntheticEvent<HTMLImageElement>) => void
  onLoad?: (event: React.SyntheticEvent<HTMLImageElement>) => void
}

const BasicImage = ({ url, alternateText, defaultWidth, onError, onLoad }: BasicImageProps) =>
  <picture>
    <source
      type="image/webp"
      srcSet={`${scaleImageUrl(url, defaultWidth, 'webp')} 1x,
               ${scaleImageUrl(url, defaultWidth * 2, 'webp')} 2x`}
    />
    <source
      srcSet={`${scaleImageUrl(url, defaultWidth, 'jpg')} 1x,
               ${scaleImageUrl(url, defaultWidth * 2, 'jpg')} 2x`}
    />
    <img onError={onError} onLoad={onLoad}
      src={scaleImageUrl(url, defaultWidth, 'jpg')}
      alt={alternateText} />
  </picture>

export default BasicImage
